<template>
<b-container fluid>
    <b-row>
        <b-col lg="8">
            <card>
                 <ChannelTable @selectItem="onSelectItem" @newItem="onNewItem" />
            </card>
        </b-col>
        <b-col>
             <InfoCard v-if="action == ''"></InfoCard>
        </b-col>
    </b-row>
</b-container>

</template>

<script>

import ChannelTable from '@/components/Content/Channels/ChannelTable'

export default {
    components: {
        ChannelTable
    }, 
    data() {
        return {
            action: ""        
        }
    },
    methods: {
        onNewItem() {
            this.item = null;
            this.action = "new"
      
        },
        onSelectItem(item) {
            this.item = item;
            this.action = "item"
        }
       
    }
}
</script>
